import React, { useState } from 'react';
import { 
  Box, 
  Grid, 
  Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DocumentCard from './DocumentCard';
import Heading from "../../../../../../../components/Heading";
import PrimaryButton from "../../../../../../../components/Button/Button";
import DocumentIcon from "../../../../../../../styles/svg/upload-doc.svg";
import DocumentUploadModal from './DocumentUploadModal';
import { isAdmin } from '../../../../../../../utils/helpers';

const DocumentsSection = ({ documents, ticketId, refetch }) => {
  const [openUploadModal, setOpenUploadModal] = useState(false);

  const handleOpenUploadModal = () => {
    setOpenUploadModal(true);
  };

  const handleCloseUploadModal = () => {
    setOpenUploadModal(false);
  };

  return (
    <Box className="documents-section">
      <Heading title={"Document Uploads"} icon={DocumentIcon}>
        {isAdmin() &&<PrimaryButton
          variant="contained"
          className={`capitalize btn-bg-orange`}
          onClick={handleOpenUploadModal}
          startIcon={<AddIcon />}
        >
          Uploads
        </PrimaryButton>}
      </Heading>

      <DocumentUploadModal
        open={openUploadModal}
        handleClose={handleCloseUploadModal}
        ticketId={ticketId}
        refetch={refetch}
      />

      <Grid container spacing={2} className="documents-grid">
        {documents.length === 0 && (
          <Grid item xs={12}>
            <Box sx={{ textAlign: 'center', py: 4 }}>
              <Typography variant="body1" color="text.secondary">
                No documents found
              </Typography>
            </Box>
          </Grid>
        )}
        {documents.map((doc) => (
          <Grid item xs={12} md={6} key={doc.id}>
            <DocumentCard document={doc} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default DocumentsSection; 